import { AnyAction, Middleware } from '@reduxjs/toolkit';
import { setDownloadList } from '~/store/resource';
import { FileStatus, TDownloadList } from '~/store/resource/resource.type';
import { downloadCompleteEvent } from './index';

/**
 * 監聽 setDownloadList action，找出 status 從非-finish 變成 finish 的項目
 * 為每個 fire 一次 download_complete 事件
 *
 * 只有 Electron 會 dispatch setDownloadList（web 下載不經由主程序 IPC）
 */

type StateShape = { resource: { downloadList: TDownloadList } };

export const downloadCompleteMiddleware: Middleware =
  storeAPI => next => (action: AnyAction) => {
    if (!setDownloadList.match(action)) {
      return next(action);
    }

    const prevList = (storeAPI.getState() as StateShape).resource.downloadList;
    const result = next(action);
    const nextList = (storeAPI.getState() as StateShape).resource.downloadList;

    findNewlyCompleted(prevList, nextList).forEach(({ url, filename }) => {
      downloadCompleteEvent({
        resources_url: url,
        resources_name: filename,
      });
    });

    return result;
  };

const findNewlyCompleted = (
  prev: TDownloadList,
  next: TDownloadList,
): { url: string; filename: string }[] => {
  const completed: { url: string; filename: string }[] = [];
  for (const [id, formats] of Object.entries(next)) {
    for (const [fileFormat, item] of Object.entries(formats)) {
      if (item.status !== FileStatus.finish) continue;
      const prevItem = prev[id]?.[fileFormat];
      if (prevItem && prevItem.status !== FileStatus.finish) {
        completed.push({ url: item.url, filename: item.filename });
      }
    }
  }
  return completed;
};
